import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';

import { PortalCurrencyPipe } from '@app/pipes/portal-currency.pipe';

@Component({
  selector: 'save-badge',
  templateUrl: './save-badge.component.html',
  styles: [':host { display: contents; }'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SaveBadgeComponent {
  @Input() amount: number;

  portalCurrency = inject(PortalCurrencyPipe);

  get label() {
    return `You're saving ${this.portalCurrency.transform(this.amount)}`;
  }
}
